'use client';

import { RoundedBorder } from '../../../../_libs/components/components';
import {
  ProductsToHelpSupport,
  ProductUsedForHealing,
} from './libs/components/components';
import WoundAreasBody from '../../../../../../public/svg/healing-navigator/Wound_areas_body.svg';
import { AppRoute } from '../../../../../libs/enums/enums';

const OptionsToTalkAbout = () => {
  return (
    <div className="mx-5 lg:ml-[55px] mt-12 lg:mt-24 bg-white max-w-[1362px] rounded-t-[16px] overflow-hidden border-b-ogn-bright-yellow border-b-[3px] mb-14">
      <div className="w-full bg-ogn-blue lg:pt-11 pb-9 py-6 relative rounded-t-[16px]">
        <h3 className="text-[22px] lg:text-[min(2.4vw,36px)] pr-12 lg:pr-0 ml-[36px] lg:ml-[min(6.3vw,_8rem)] lg:mr-72 text-white max-w-[780px] lg:leading-[42px] font-roboto-condensed rounded-t-[16px]">
          Thank you. Here is some information about options that you can talk
          about with your healthcare provider.
        </h3>
        <WoundAreasBody className="lg:block hidden absolute top-[64px] w-[210px] h-[565px] right-[10%] z-0" />
      </div>
      <div className="w-full pt-6 relative z-10">
        <div className="text-ogn-blue text-[22px] lg:text-[min(2.2vw,30px)] lg:leading-[42px] pr-12 lg:pr-0 font-bold space-y-7 ml-[36px] lg:ml-[min(6.3vw,_8rem)] lg:mr-80 max-w-[730px] font-roboto-condensed">
          <p>
            Organogenesis offers many solutions that can help manage or heal
            wounds from head-to-toe for many different types of acute and
            chronic wounds.
          </p>
          <p>
            Acute wounds may be the result of a recent injury or surgery. A
            chronic wound is any wound that has been present for a long time and
            is not healing as it should.
          </p>
        </div>
        <WoundAreasBody className="lg:hidden block w-[210px] mx-auto mt-8 h-[565px]" />
        <div className="flex items-center justify-center mt-16">
          <div className="flex lg:flex-row gap-y-4 flex-col justify-between items-center border-[1px] text-ogn-blue border-ogn-blue rounded-[16px] py-3 px-7 max-w-[640px] w-full font-roboto-condensed">
            <div className="flex w-full lg:w-auto justify-start items-center gap-x-2">
              <div className="bg-ogn-bright-yellow w-[34px] h-[34px] rounded-full"></div>
              <div className="text-[18px] lg:text-[min(1.3vw,18px)] font-bold ">
                Head-to-toe wounds
              </div>
            </div>
            <div className="flex w-full lg:w-auto justify-start items-center gap-x-2">
              <div className="bg-ogn-blue w-[34px] h-[34px] rounded-full shrink-0"></div>
              <div className="text-[18px] lg:text-[min(1.3vw,18px)] font-bold ">
                Diabetic Foot and Venous Leg Ulcers
              </div>
            </div>
          </div>
          <svg
            className="lg:block hidden lg:mr-32"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="33"
            viewBox="0 0 16 33"
            fill="none"
          >
            <path d="M16 16.5L0 33L0 0L16 16.5Z" fill="#002855" />
          </svg>
        </div>
        <ProductsToHelpSupport />
        <ProductUsedForHealing />
        <div className="max-w-[995px] mx-auto text-ogn-grey text-[18px] mt-5 space-y-2">
          <div>
            Affinity, Novachor, and PuraPly are registered trademarks of
            Organogenesis Inc.
          </div>
          <div>
            Apligraf is a registered trademark of Novartis; Cygnus Dual, VIA
            Matrix, and Cygnus Matrix are registered trademarks of Vivex
            Biologics, Inc.
          </div>
        </div>
        <RoundedBorder
          to={AppRoute.RESOURCES_SUPPORT}
          className="max-w-[1040px] mx-auto w-fit mt-16 mb-12 lg:mb-24"
          caption="Learn more about how these products can help"
          captionClassName="text-[28px] lg:text-[min(2.2vw,42px)] lg:pr-[56px]"
        />
      </div>
    </div>
  );
};

export { OptionsToTalkAbout };
